import clsx from 'clsx';
import { observer } from 'mobx-react-lite';
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState
} from 'react';
import './styles.scss';

const InputUI = observer(forwardRef(function InputUI(
  {
    className = "",
    text,
    onChange,
    value: controlledValue,
    withClear,
    options,
    readOnly,
    ...props
  },
  ref
) {
  const inputRef = useRef(null);
  const [value, setValue] = useState(controlledValue ?? '');

  useEffect(() => {
    if (controlledValue !== undefined) {
      setValue(controlledValue);
    }
  }, [controlledValue]);

  useImperativeHandle(ref, () => inputRef.current);

  const handleClear = () => {
    if (readOnly) return;
    setValue('');
    if (inputRef.current) {
      inputRef.current.value = '';
      inputRef.current.focus();
    }
    if (onChange) {
      onChange({ target: { value: '' } });
    }
  };

  const handleChange = (e) => {
    if (readOnly) return;
    setValue(e.target.value);
    if (onChange) {
      onChange(e);
    }
  };

  return (
    <div
      className={clsx(
        'ui-input',
        className,
        { '_filled': value && value.length > 0 }
      )}
    >      
      {text && <span className="ui-input__label">{text}</span>}

      <input
        ref={inputRef}
        className="ui-input__field"
        value={value}
        onChange={handleChange}
        {...props}
      />

      {withClear && value && (
        <span className="ui-input__clear" onClick={handleClear}>
          ×
        </span>
      )}

      {options && <div className='ui-input__options'>{options}</div>}
    </div>
  );
}));

export default InputUI;
